/* eslint-disable import/prefer-default-export */
import * as ReduxHelpers from '@src/utils/reduxHelpers'
// Action Types
export const GET_SUPPORTED_RESOURCE_TYPES_SUCCESS =
  ReduxHelpers.Types.createActionType(
    'cam/shell',
    'GET_SUPPORTED_RESOURCE_TYPES_SUCCESS'
  )

export const SET_STATUS_SSO = ReduxHelpers.Types.createActionType(
  'cam/shell',
  'SET_STATUS_SSO'
)

export const CLEANER_SUPPORTED_RESOURCE_TYPES =
  ReduxHelpers.Types.createActionType(
    'cam/shell',
    'CLEANER_SUPPORTED_RESOURCE_TYPES'
  )

export const SET_USE_IDN_PATH_FLAG = ReduxHelpers.Types.createActionType(
  'cam/shell',
  'SET_USE_IDN_PATH_FLAG'
)

export const SET_TEXTBOX_TOOLTIP_FIX_FLAG = ReduxHelpers.Types.createActionType(
  'cam/shell',
  'SET_TEXTBOX_TOOLTIP_FIX_FLAG'
)
